import { 
    CREATE_USER_SUCCESS,
    SET_ALL_USERS,
    SET_USER_BY_ID,
    SET_MODULES_LIST,
    SET_USER_MODULES,
    SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA,
    SET_USERS_ASSESSMENTS_EXCEL_DATA,
    SET_USER_ATTEMPTS_BY_ID,
    SET_USERS_COST_CENTERS_FILTER_LIST,
    SET_USERS_HOME_COST_CENTERS_FILTER_LIST,
    SET_USERS_LATEST_SCORE_FILTER_LIST,
    SET_USERS_BY_COST_CENTER,
    SET_SAVE_USER_BY_COST_CENTER,
    SET_USER_COST_CENTERS,
    SET_USER_COST_CENTERS_MODULES_LIST,
    SET_SAVE_USER_COST_CENTERS_MODULES
 } from "./UsersTypes";

 const initialState = {
    isSaveUserByCostCenter: null,
    usersBySearchText: [],
    usersByCostCenter: []
}

 const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case CREATE_USER_SUCCESS:
            return {
                ...state,
                userCreated: action.flag,
            };
        case SET_ALL_USERS:
            return {
                ...state,
                allUsersList: action.usersList,
            };
        case SET_USER_BY_ID:
            return {
                ...state,
                userById: action.userById,
            };
        case SET_MODULES_LIST:
            return {
                ...state,
                modulesList: action.modulesList,
            }; 
        case SET_USER_MODULES:
            return {
                ...state,
                userModules: action.userModules,
            }; 
        case SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA:
            return {
                ...state,
                previousYearResultsData: action.response,
            }; 
        case SET_USERS_ASSESSMENTS_EXCEL_DATA:
            return {
                ...state,
                userAssessmentsExcelData: action.response,
            }; 
        case SET_USER_ATTEMPTS_BY_ID:
            return {
                ...state,
                userAttemptsById: action.response,
            }; 
        case SET_USERS_COST_CENTERS_FILTER_LIST:
            return {
                ...state,
                usersCostCentersList: action.response,
            }; 
        case SET_USERS_HOME_COST_CENTERS_FILTER_LIST:
            return {
                ...state,
                usersHomeCostCentersList: action.response,
            }; 
        case SET_USERS_LATEST_SCORE_FILTER_LIST:
            return {
                ...state,
                usersLatestScoresList: action.response,
            }; 

        case SET_USERS_BY_COST_CENTER:
            return {
                ...state,
                usersByCostCenter: action.usersByCostCenter,
            };
        case SET_SAVE_USER_BY_COST_CENTER:
            return {
                ...state,
                isSaveUserByCostCenter: action.isSaveUserByCostCenter,
            };
        case SET_USER_COST_CENTERS:
            return {
                ...state,
                userCostCentersDropdownList : action.response,
            };
        case SET_USER_COST_CENTERS_MODULES_LIST:
            return {
                ...state,
                userCostCentersModulesList : action.response,
            };
        case SET_SAVE_USER_COST_CENTERS_MODULES:
            return {
                ...state,
                isUserCostCentersModulesSaved : action.response,
            };
        default:
            return state;
    }
}

export default reducers